import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20illustration%20of%20a%20cozy%20reading%20nook%20with%20warm%20lighting%2C%20open%20books%20and%20comic%20pages%20floating%20magically%20in%20the%20air%2C%20soft%20warm%20amber%20and%20cream%20tones%2C%20dreamy%20atmosphere%2C%20whimsical%20fantasy%20vibe%2C%20clean%20illustration%20style%2C%20no%20text&width=1920&height=1080&seq=hero-bg-xiangxiang&orientation=landscape"
        alt="香香漫画 - 韩国漫画免费阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 rounded-full text-sm font-medium mb-6 whitespace-nowrap animate-[fadeInUp_0.6s_ease-out]">
            <i className="ri-sparkling-2-line mr-1.5"></i>海量韩漫免费阅读
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-5 leading-tight animate-[fadeInUp_0.6s_ease-out_0.1s]">
            韩国漫画
            <span className="text-primary-400">免费阅读</span>
            <br />
            尽在香香漫画
          </h1>
          <p className="text-base md:text-lg text-background-200 mb-8 max-w-xl mx-auto leading-relaxed animate-[fadeInUp_0.6s_ease-out_0.2s]">
            海量优质韩漫，每日更新，流畅下拉式阅读体验。恋爱、奇幻、动作、悬疑，你想要的这里都有。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-[fadeInUp_0.6s_ease-out_0.3s]">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap shadow-lg shadow-primary-500/25 hover:shadow-primary-500/40"
            >
              开始阅读 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 backdrop-blur-sm rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap border border-background-50/20"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-xl"></i>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}